export const DATE_TIME_CONSTANTS = {
  YYYY_MM_DD: "YYYY-MM-DD",
  hh_mm_ss: "hh:mm:ss",
  hh_mm_a: "hh:mm a",
  hh_mm_A: "hh:mm A",
  HH_mm: "HH:mm",
  minutes: "minutes",
  D_MMMM_YYYY: "D MMMM YYYY",
  D_MMM_YYYY: "D MMM YYYY",
  DD_MMM_YYYY: "DD MMM YYYY",
  ddd: "ddd",
  MMM: "MMM",
  MMM_YYYY: "MMM, YYYY",
  DD: "DD",
  DAY: "day",
  MMMM_YYYY: "MMMM YYYY",
  DO_MM_YYY_hh_mm_a: "Do, MMM YYYY hh:mm a",
  DO_MMM_YYYY_h_mm_a: "Do MMM, YYYY, h:mm A",
  SECOND: "SECOND",
  hh_mm: "hh:mm",
  DO_MMM: "Do MMM",
  MMM_ddd: "MMM, ddd",
  MMM__YYYY: "MMM YYYY",
  D_MMM_YY: "D MMM YY",
  DDD_D_MMM: "ddd, D MMM",
  DD_MMM_YYYY_HH_mm: "DD MMM YYYY HH:mm",
  MONTH: "month",
  YYYY_MM_DD_HH_mm: "YYYY-MM-DD HH:mm",
  D_MMM: "D MMM",
  D: "D",
  D_MMMM_dddd: "D MMMM, dddd",
  dddd_MMM_DD: "dddd, MMM DD",
  h_mm_A_D_MMM_YYYY: "h:mm A, D MMM YYYY",
  ddd_MMM_DD: "ddd, MMM DD",
  Do_MMM_YYYY: "Do MMM, YYYY",
  Do_MMM_YYYY_h_mm_A: "Do MMM YYYY, h:mm a",
  ddd_MMM_DD_h_mm_A: "ddd, MMM DD | h:mm a",
  YYYY: "YYYY",
  DD_MM_YYYY: "DD-MM-YYYY",
  DD_MMM: "DD MMM",
  YYYY_MM_DD_HH_mm_ss: "YYYY-MM-DD HH:mm:ss",
  D_MMM_ddd: "D MMM, ddd",
  LT: "LT",
  D_MMM_YYYY_h_mm_a: "D MMM YYYY, h.mm a",
  DATE_MESSAGE: "ddd, Do MMMM YYYY",
  SENT_MESSAGE: "h:mm a",
  Do_MMM_hh_mm_a: "Do MMM, hh:mm a",
  HH_mm_ss: "HH:mm:ss",
  ddd_MMM_DD_hh_mm_A: "ddd, MMM DD | hh:mm a",
  MMMM_DD_hh_mm_A: "MMMM DD, hh:mm A",
  D_MMM_YY_h_mm_A: "D MMM, YY h:mm A",
  hh_mm_A_DD_MMM_ddd: "hh:mm a, DD MMM, dddd",
  DD_MMM_ddd: "DD MMM, ddd",
  DD_MMM_ddd_hh_mm_a: "DD MMM, ddd, hh:mm a",
  YYYY_MM_DD__HH_mm: "YYYY-MM-DD:HH:mm",
  week: "week",
  DD_MMM_YY: "DD MMM, YY",
  dddd_DD_MMM_YYYY: "dddd, DD MMM YYYY",
  ddd_DD_MMM_YYYY: "ddd, DD MMM YYYY",
  DD_MMM__YYYY: "DD MMM, YYYY",
  DD_MMM_YYYY_hh_mm_A: "DD MMM YYYY, hh:mm A",
  hh_mm_A_D_MMM_ddd_YYY: "hh:mm A, D MMM, dddd YYYY",
  MMMM__YYYY: "MMMM, YYYY",
  MMMM_DD_YYYY_hh_mm_A: "MMMM DD, YYYY hh:mm A",
  DD_MMM_YYYY_h_A: "DD MMM YYYY, h A",
  Do_MMM_YYYY_hh_mm_A: "Do MMM YYYY, h:mm A",
  DD_MMM__YYYY_hh_mm_A: "DD MMM, YYYY hh:mm A",
  YY: "YY",
  Do_MMM_YYYY_NO_COMMA: "Do MMM YYYY",
  ddd_D_MMM_YYYY: "ddd, D MMM YYYY",
  dddd_Do_MMM_YYYY: "dddd, Do MMM YYYY",
};
